import { ReactElement, ReactNode } from "react";
import { createPortal } from "react-dom";

export type PortalProps = {
	children: ReactNode;
	container: Element | string;
};

export const Portal = (props: PortalProps): ReactElement => {
	const {
		children,
		container
	} = props;

	return createPortal(children, resolveElement(container));
};

Portal.displayName = "Portal";

function resolveElement (container: Element | string): Element {
	if (typeof container === "string") {
		const element: Element | null = document.querySelector(container);
		if (!element) {
			throw new Error(`Element with selector '${container}' not found in the dom`);
		}
		return element;
	}

	return container;
};
